import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Footer, Header, LinkList } from '../../../components';
import * as NegotiationActions from '../../../actions/NegotiationActions';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import './style.scss';

class ListNegotiation extends Component {

  componentDidMount = () => {

    window.scrollTo(0, 600)
    this.props.searchNegotiations(
      this.props.loggedUser.executive,
      this.props.registerPerPage

    );
  };

  sort = column => {
    const direction = !this.props.orderDirection
      ? 'DESC'
      : this.props.orderDirection === 'ASC'
      ? 'DESC'
      : 'ASC';
    this.props.sortNegotiationList(
      column,
      direction,
      this.props.loggedUser.executive,
      this.props.registerPerPage,
      this.props.negotiationsSearch
    );
  };

  redirectToAddNegotiation = () => {
  if (this.props.loggedUser.executive.idExecutivo > 0)
      this.props.redirectToAddNegotiation();
    else this.props.userIsNotExecutive();
  };

  showAll = () => {
    this.props.searchAllNegotiations(
      this.props.loggedUser.executive,
      this.props.negotiationsSearch,
      this.props.orderBy,
      this.props.orderDirection
    );
  };

  handleSearchSubmit = event => {
    event.preventDefault();
    this.props.searchNegotiations(
      this.props.loggedUser.executive,
      this.props.registerPerPage,
      this.props.negotiationsSearch,
      this.props.orderBy,
      this.props.orderDirection
    );
  };

  handleChangeInputFilter = event => {
    const { value } = event.target;
    this.props.updateInputFilter(value);
  };

  redirectToDetail = id => {
    this.props.redirectToDetail(id);
  };

  render = () => (
    <div className="pre-sale" id="venda">
      <Header showBackButton={true} />
      <LinkList selected={true} />
      <div>
        <div className="container">
          <div className="row list-box">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
              <p className="text last-sale">
                <span className="constrant-color">
                  {this.props.registerPerPage ==
                  process.env.REACT_APP_MAX_REGISTER_PER_PAGE
                    ? 'Todas '
                    : `${this.props.negotiations.length} Últimas `}
                </span>
                pré-vendas registradas
              </p>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 text-right add-box add-mobile">
              <button
                className="btn btn-pre-sale"
                onClick={this.redirectToAddNegotiation}
              >
                PRÉ-VENDA
                <i className="fas fa-plus-circle icon-plus" />
              </button>
            </div>
            <form onSubmit={this.handleSearchSubmit}>
              <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12 text-right filter-box">
                <input
                  type="text"
                  placeholder="Filtrar informações..."
                  className="form-control"
                  value={this.props.negotiationsSearch}
                  onChange={e => this.handleChangeInputFilter(e)}
                  onBlur={e => this.handleSearchSubmit(e)}
                />
                <i className="fas fa-filter icon-filter" />
              </div>
            </form>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 text-right add-box add-desktop">
              <button
                className="btn btn-pre-sale"
                onClick={this.redirectToAddNegotiation}
              >

                PRÉ-VENDA
                <i className="fas fa-plus-circle icon-plus" />
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text" onClick={e => this.sort('Data')}>
                    Data de Criação
                    {this.props.orderBy === 'Data' &&
                      this.props.orderDirection === 'DESC' && (
                        <i className="fas fa-sort-amount-down sort-icon" />
                      )}
                    {this.props.orderBy === 'Data' &&
                      this.props.orderDirection === 'ASC' && (
                        <i className="fas fa-sort-amount-up sort-icon" />
                      )}
                  </th>
                  <th className="text" onClick={e => this.sort('Cliente')}>
                    Cliente
                    {this.props.orderBy === 'Cliente' &&
                      this.props.orderDirection === 'DESC' && (
                        <i className="fas fa-sort-amount-down sort-icon" />
                      )}
                    {this.props.orderBy === 'Cliente' &&
                      this.props.orderDirection === 'ASC' && (
                        <i className="fas fa-sort-amount-up sort-icon" />
                      )}
                  </th>
                  <th className="text" onClick={e => this.sort('Agencia')}>
                    Agência
                    {this.props.orderBy === 'Agencia' &&
                      this.props.orderDirection === 'DESC' && (
                        <i className="fas fa-sort-amount-down sort-icon" />
                      )}
                    {this.props.orderBy === 'Agencia' &&
                      this.props.orderDirection === 'ASC' && (
                        <i className="fas fa-sort-amount-up sort-icon" />
                      )}
                  </th>
                  <th className="text" onClick={e => this.sort('Executivo')}>
                    Nome
                    {this.props.orderBy === 'Executivo' &&
                      this.props.orderDirection === 'DESC' && (
                        <i className="fas fa-sort-amount-down sort-icon" />
                      )}
                    {this.props.orderBy === 'Executivo' &&
                      this.props.orderDirection === 'ASC' && (
                        <i className="fas fa-sort-amount-up sort-icon" />
                      )}
                  </th>
                  <th className="text" onClick={e => this.sort('Numero')}>
                    Número da pré-venda
                    {this.props.orderBy === 'Numero' &&
                      this.props.orderDirection === 'DESC' && (
                        <i className="fas fa-sort-amount-down sort-icon" />
                      )}
                    {this.props.orderBy === 'Numero' &&
                      this.props.orderDirection === 'ASC' && (
                        <i className="fas fa-sort-amount-up sort-icon" />
                      )}
                  </th>
                  <th className="text">Rateio</th>
                  <th className="text">% Desconto</th>
                  <th className="text">Valor Bruto</th>
                  <th className="text">Status da Venda</th>
                </tr>
              </thead>
              <tbody>
                {this.props.negotiations.map(n => (
                  <tr key={n.id} onClick={() => this.redirectToDetail(n.id)}>
                    <td>{moment(n.dataCadastro).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{n.cliente.nome}</td>
                    <td>{n.agencias.map(a => (<p>{a.nome}</p>))}</td>
                    <td>{n.executivo.nomeExecutivo}</td>
                    <td>{n.numeroReferencia}</td>
                    <td>{n.rateio ? 'Sim' : 'Não'}</td>
                    <td>
                      <NumberFormat
                        value={n.percentualDesconto}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        suffix={' %'}
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </td>
                    <td className="td-amount">
                      <NumberFormat
                        value={n.valor}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        prefix={' R$ '}
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </td>
                    <td>{n.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {!this.props.negotiations ||
            (this.props.negotiations.length === 0 && (
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                <span className="text">Nenhuma pré-venda encontrada</span>
              </div>
            ))}
          {this.props.negotiations && this.props.negotiations.length > 0 && (
            <div className="text-center pagination-box">
              <button
                className={`btn btn-show-all ${
                  this.props.registerPerPage ==
                  process.env.REACT_APP_MAX_REGISTER_PER_PAGE
                    ? 'opacity'
                    : ''
                }`}
                onClick={this.showAll}
              >
                MOSTRAR TODAS
              </button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = ({ negotiationReducer, auth }) => {
  return {
    ...negotiationReducer,
    ...auth
  };
};

export default connect(
  mapStateToProps,
  { ...NegotiationActions }
)(ListNegotiation);
